<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="reset"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="{ span: 8 }" :model="target" :rules="rules" :wrapper-col="{ span: 16 }">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.ownerNo')">
              <vxe-input v-model="target.owner.no" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.ownerName')">
              <vxe-input v-model="target.owner.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.itemNo')" prop="item.no">
              <vxe-input v-model="target.item.no" :editable="false" style="width: 100%" @click="search('itemModal',{ 'owner.id': target.owner.id })"/>
              <item-modal ref="itemModal" @change="(e)=>change(e,'item')"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.itemName')">
              <vxe-input v-model="target.item.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.specification')" prop="pack.specification">
              <vxe-input v-model="target.pack.specification" :editable="false" style="width: 100%" @click="search('packModal',{'item.id':target.item.id,appearance:1})"/>
              <pack-modal ref="packModal" @change="(e)=>change(e,'pack')"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.factor')">
              <vxe-input v-model="target.pack.factor" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.uom')">
              <vxe-input v-model="target.pack.uom" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.lotNo')" prop="lot.no">
              <vxe-input v-model="target.lot.no" :editable="false" style="width: 100%" @click="search('lotModal',{'item.id':target.item.id})"/>
              <lot-modal ref="lotModal" @change="(e)=>change(e,'lot')"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.productionDate')">
              <vxe-input v-model="target.lot.productionDate" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.validUntil')">
              <vxe-input v-model="target.lot.validUntil" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.manufacturer')">
              <vxe-input v-model="target.lot.manufacturer" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.producingArea')">
              <vxe-input v-model="target.lot.producingArea" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.approvalNo')">
              <vxe-input v-model="target.lot.approvalNo" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.batchNo')" prop="batch.no">
              <vxe-input v-model="target.batch.no" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.logicalStore')" prop="logicalStore.id">
              <vxe-select v-model="target.logicalStore.id" :options="logicalStores" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.location')" prop="location.no">
              <vxe-input v-model="target.location.no" :editable="false" style="width: 100%" @click="search('locationModal')"/>
              <location-modal ref="locationModal" @change="(e)=>change(e,'location')"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.containerNo')">
              <vxe-input v-model="target.container.no" :editable="false" style="width: 100%" @click="search('containerModal')"/>
              <container-modal ref="containerModal" @change="(e)=>change(e,'container')"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item ref="quantity" :label="$t('business.label.quantity')" prop="quantity">
              <vxe-number-input v-model="target.quantity" :min="0" style="width: 100%" @change="onQuantityChanged(target.quantity, target.pack.factor, target)"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.number')">
              <vxe-input v-model="target.case" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfEach')">
              <vxe-input v-model="target.each" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.serialNumberNo')">
              <vxe-input v-model="target.serialNumber.no" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.reason')" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" prop="reasons">
              <vxe-textarea v-model="target.reasons" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
  </div>
</template>

<script>
import api from '@/api'
import Vue from 'vue'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import ItemModal from '@/views/modal/ItemModal.vue'
import LotModal from '@/views/modal/LotModal.vue'
import PackModal from '@/views/modal/PackModal.vue'
import { post } from '@/api/Api'
import { Batch } from '@/api/dto/common/Batch'
import { Lot } from '@/api/dto/common/Lot'
import { Pack } from '@/api/dto/common/Pack'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import { Identifier } from '@/api/dto/Identifier'
import { getDictionaries, onQuantityChanged } from '@/utils/util'

export default {
  name: 'TemporaryCountingDetail',
  components: { ContainerModal, LocationModal, LotModal, PackModal, ItemModal },
  props: {
    orderType: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      source: new InventoryFactoryView(),
      target: new InventoryFactoryView(),
      logicalStores: [],
      rules: {
        'item.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'pack.specification': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'lot.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'logicalStore.id': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'location.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        quantity: [{ required: true, type: 'number', message: this.$t('message.canNotBeEmpty') }],
        reasons: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    getDictionaries('LOGICAL_STORE').then(result => {
      this.logicalStores = result
    })
  },
  methods: {
    onQuantityChanged,
    back() {
      this.$emit('back')
    },
    fetch(data) {
      this.source = new InventoryFactoryView(data)
      this.source.quantity = data.inventory.availableQuantity
      onQuantityChanged(this.source.quantity, this.source.pack.factor, this.source)
      this.reset()
    },
    search(refName, args) {
      this.$refs[refName].open(args)
    },
    change(data, fieldName) {
      if (fieldName === 'item') {
        this.target.pack = new Pack()
        this.target.lot = new Lot()
        this.target.batch = new Batch()
      }
      this.target[fieldName] = new Identifier(data[0])
    },
    reset() {
      this.target = Object.assign(new InventoryFactoryView(), this.source)
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const order = { warehouse: this.warehouse, orderType: this.orderType, owner: this.source.owner }
          //region 调整前
          const source = {}
          source.sku = {
            id: this.source.sku.id,
            item: this.source.item,
            pack: this.source.pack,
            lot: this.source.lot,
            batch: this.source.batch,
            logicalStore: this.source.logicalStore
          }
          source.serialNumber = this.source.serialNumber.skipNulls()
          source.location = this.source.location
          source.container = this.source.container.skipNulls()
          source.inventoryState = this.source.inventory.inventoryState
          source.quantity = -this.source.quantity
          source.reasons = this.target.reasons
          //endregion
          //region 调整后
          const target = {}
          target.sku = {
            item: this.target.item,
            pack: this.target.pack,
            lot: this.target.lot,
            batch: this.target.batch,
            logicalStore: this.target.logicalStore
          }
          target.serialNumber = this.target.serialNumber.skipNulls()
          target.location = this.target.location
          target.container = this.target.container.skipNulls()
          target.inventoryState = this.target.inventory.inventoryState
          target.quantity = this.target.quantity
          target.reasons = this.target.reasons
          //endregion
          order.details = [source, target]

          post(api.countingSave, { type: 'inventoryCounter' }, order).then(res => {
            if (res.success) {
              this.$message.success(this.$t('message.saveSuccess'))
              this.back()
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>